module.exports = __webpack_public_path__ + "static/media/Data Privacy Policy-BIL.c51aa86d.pdf";